<app-card #card
          [classes]="classes"
          [paddingClasses]="paddingClasses"
          [showTopImage]="showTopImage"
          [showBorder]="showBorder"
          [limitDescription]="limitDescription"
          [imageUrl]="imageUrl"
          [mediaItems]="mediaItems"
          [mobileMode]="mobileMode"
          [topImageLink]="topImageLink"
          [topImageLinkText]="topImageLinkText"
          [topLeft]="topLeft"
          [topLeftLink]="topLeftLink"
          [topLeftClasses]="topLeftTextClasses"
          [topLeftTextClasses]="topLeftTextClasses"
          [topRight]="topRight"
          [topRightClasses]="topRightClasses"
          [topRightTextClasses]="topRightTextClasses"
          [title]="title"
          [titleClasses]="titleClasses"
          [subTitle]="subTitle"
          [subtitleClasses]="subtitleClasses"
          [description]="description"
          [descriptionClasses]="descriptionClasses"
          [bottomLeft]="bottomLeft"
          [bottomLeftClasses]="bottomLeftClasses"
          [buttonClasses]="buttonClasses"
          [buttonRoute]="buttonRoute"
          [buttonText]="buttonText"
          [linkText]="linkText"
          [linkRoute]="linkRoute"
          [linkClasses]="linkClasses"
          [fullCardClick]="fullCardClick"
          [bottomRight]="bottomRight"
          [bottomRightClasses]="bottomRightClasses"
          [bottomRightTextClasses]="bottomRightTextClasses">
  <ng-content></ng-content>
</app-card>
